/** Business rules shared by client (for UX) and server (authoritative). */
export const COOP_BALANCE_LIMIT_HOURS = 30;
export const COOP_HOUR_INCREMENT = 0.25;
export const COOP_AUTO_FINALIZE_HOURS = 48;
export const MAX_CHILDREN = 12;
/** Profile "about me" — a line or two, like a bio. */
export const MAX_ABOUT = 280;
export const MAX_CIRCLE_TITLE = 60;
export const MAX_MESSAGE_LENGTH = 4000;
export const PASSWORD_MIN_LENGTH = 10;
/** Requester may post only while balance is above the deficit floor. */
export function canRequestCare(balanceHours) {
    return balanceHours > -COOP_BALANCE_LIMIT_HOURS;
}
/** Sitter may take sits only while balance is below the surplus ceiling. */
export function canOfferCare(balanceHours) {
    return balanceHours < COOP_BALANCE_LIMIT_HOURS;
}
export function roundToIncrement(hours) {
    return Math.round(hours / COOP_HOUR_INCREMENT) * COOP_HOUR_INCREMENT;
}
/** Age in whole months as of `at`, from a YYYY-MM-DD birth date. Ages are always computed, never stored. */
export function ageInMonths(birthDate, at = new Date()) {
    const [y, m, d] = birthDate.split("-").map(Number);
    let months = (at.getUTCFullYear() - y) * 12 + (at.getUTCMonth() + 1 - m);
    if (at.getUTCDate() < d)
        months -= 1;
    return Math.max(0, months);
}
export function formatAge(birthDate, at = new Date()) {
    const months = ageInMonths(birthDate, at);
    if (months < 24)
        return `${months} mo${months === 1 ? "" : "s"}`;
    const years = Math.floor(months / 12);
    return `${years} yr${years === 1 ? "" : "s"}`;
}
/** "Andersonville, Edgewater Glen" (+N) — shown under an area's official name so moms recognize it. */
export function areaAka(a, max = 3) {
    const n = a.neighborhoods;
    return n.length <= max ? n.join(", ") : `${n.slice(0, max).join(", ")} +${n.length - max}`;
}
/** Search an area by its official name or any neighborhood in it ("anders" finds Edgewater). */
export function areaMatches(a, q) {
    const s = q.trim().toLowerCase();
    return !s || a.name.toLowerCase().includes(s) || a.neighborhoods.some((n) => n.toLowerCase().includes(s));
}
//# sourceMappingURL=rules.js.map